const EmptyData = ({ title = "رکوردی برای نمایش یافت نشد" }) => {
  return <div className="alert alert-info text-center m-0">{title}</div>;
};

export default EmptyData;
